import { z } from 'zod';

export const maintenanceSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  details: z.string().min(1, 'Details are required'),
  date_completed: z.string().min(1, 'Date completed is required'),
  status: z.enum(['completed', 'pending', 'scheduled', 'overdue'], {
    required_error: 'Status is required',
  }),
  cost: z.number().min(0, 'Cost must be zero or positive').default(0),
  repeating: z.boolean().default(false),
  frequency: z.string().optional(),
  next_maintenance_date: z.string().optional(),
  maintenance_by_id: z.string().uuid().optional().nullable(),
});

export type MaintenanceFormData = z.infer<typeof maintenanceSchema>;
